/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kiotviet_Orders_Search_LabelInputs */

const vi_kiotviet_orders_search_label = /** @type {(inputs: Kiotviet_Orders_Search_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm kiếm`)
};

/**

* @param {Kiotviet_Orders_Search_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const kiotviet_orders_search_label = /** @type {((inputs?: Kiotviet_Orders_Search_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kiotviet_Orders_Search_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_kiotviet_orders_search_label(inputs)
});